var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddCircleFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3327C5.39746 18.3327 1.6665 14.6017 1.6665 9.99935C1.6665 5.39697 5.39746 1.66602 9.99984 1.66602C14.6022 1.66602 18.3332 5.39697 18.3332 9.99935C18.3332 14.6017 14.6022 18.3327 9.99984 18.3327ZM9.1665 9.16602H5.83317V10.8327H9.1665V14.166H10.8332V10.8327H14.1665V9.16602H10.8332V5.83268H9.1665V9.16602Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCircleFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-circle-fill.05e7759b.svg";
export { ForwardRef as ReactComponent };